export enum AttributeTypeInjector{
    INJECTION_DATA = 'INJECTION_DATA',
    POTENTIAL = 'POTENTIAL',
    PRESSURE_STATIC_ATTR = 'PRESSURE_STATIC_ATTR',
    INJECTION_MONITORING_ATTR = 'INJECTION_MONITORING_ATTR',
    INJECTION_ALLOCATION = 'INJECTION_ALLOCATION',
}
  